import { render, staticRenderFns } from "./vue-draggable-resizable.vue?vue&type=template&id=3f255748&scoped=true&"
import script from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"
export * from "./vue-draggable-resizable.vue?vue&type=script&lang=js&"
import style0 from "./vue-draggable-resizable.vue?vue&type=style&index=0&id=3f255748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f255748",
  null
  
)

export default component.exports